import type React from "react";
import { memo } from "react";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";
import { StreamSearchClearButton } from "@/features/study-group-stream/components/StreamSearchClearButton";

const SEARCH_INPUT_CONTAINER_CLASS = "relative flex items-center w-full gap-2";
const SEARCH_INPUT_FIELD_WRAPPER_CLASS = "relative flex-1";
const SEARCH_QUERY_ICON_CLASS =
  "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-300";
const SEARCH_QUERY_INPUT_CLASS =
  "h-10 w-full border-gray-200 bg-gray-50 pl-9 pr-8 transition-all duration-300 focus-visible:ring-1 focus-visible:ring-gray-200 focus-visible:ring-offset-0";
const SEARCH_INPUT_ACTIVE_BORDER_CLASS = "border-gray-300 ring-1 ring-gray-200";

export interface SearchQueryFieldProps {
  query: string;
  placeholder: string;
  inputAriaLabel?: string;
  onQueryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onQueryKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onQueryClear: () => void;
  clearLabel: string;
}

const SearchQueryFieldRaw: React.FC<SearchQueryFieldProps> = ({
  query,
  placeholder,
  onQueryChange,
  onQueryKeyDown,
  onQueryClear,
  clearLabel,
  inputAriaLabel,
}) => (
  <div className={SEARCH_INPUT_CONTAINER_CLASS}>
    <div className={SEARCH_INPUT_FIELD_WRAPPER_CLASS}>
      <Search className={SEARCH_QUERY_ICON_CLASS} />
      <Input
        type="text"
        value={query}
        onChange={onQueryChange}
        onKeyDown={onQueryKeyDown}
        placeholder={placeholder}
        aria-label={inputAriaLabel}
        className={cn(
          SEARCH_QUERY_INPUT_CLASS,
          query ? SEARCH_INPUT_ACTIVE_BORDER_CLASS : "",
        )}
      />
      {query && (
        <StreamSearchClearButton
          ariaLabel={clearLabel}
          onClear={onQueryClear}
        />
      )}
    </div>
  </div>
);

export const SearchQueryField = memo(SearchQueryFieldRaw);
SearchQueryField.displayName = "SearchQueryField";
